<script setup lang="ts">

</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
  <path d="M3.56725 15.5379L4.56725 11.5379H0.75975L1.13475 10.0379H4.94225L5.9615 5.96094H2.154L2.529 4.46094H6.3365L7.3365 0.460938H8.81725L7.81725 4.46094H11.952L12.952 0.460938H14.4327L13.4327 4.46094H17.2402L16.8652 5.96094H13.0577L12.0385 10.0379H15.846L15.471 11.5379H11.6635L10.6635 15.5379H9.18275L10.1827 11.5379H6.048L5.048 15.5379H3.56725ZM6.423 10.0379H10.5577L11.577 5.96094H7.44225L6.423 10.0379Z" fill="#2563EB"/>
</svg>
</template>

<style scoped lang="scss">

</style>
